if (!customElements.get("countdown-timer")) {
	class Countdown extends HTMLElement {
		constructor() {
			super();

			this.enableMockTimer =
				this.getAttribute("data-enable-mock-timer") === "true";

			if (this.enableMockTimer) {
				// get data for infinite mock timer
				const INFINITE_DAYS = this.getAttribute("data-enable-mock-picker-day")
					? Number(this.getAttribute("data-enable-mock-picker-day"))
					: 2;
				const DIFF_HOURS = this.getAttribute("data-enable-mock-picker-hours")
					? Number(this.getAttribute("data-enable-mock-picker-hours"))
					: 3;
				const now = new Date();
				const futureDate = new Date(
					now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
				);
				const year = futureDate.getFullYear();
				const month = String(futureDate.getMonth() + 1).padStart(2, "0");
				const day = String(futureDate.getDate()).padStart(2, "0");
				const hours = String(futureDate.getHours()).padStart(2, "0");
				const minutes = String(futureDate.getMinutes()).padStart(2, "0");
				this.countdownDateTo = `${year}-${month}-${day} ${hours}:${minutes}`;
			} else {
				// get data from section settings - formato: "YYYY-MM-DD HH:MM"
				this.countdownDateTo = this.getAttribute("data-date-to");
			}
			// ----------------------------------------------------------------
			this.interval;
			this.isStarted = false;
			this.setInterval();
		}

		// Función para obtener el timestamp de una fecha/hora específica en Santiago
		getSantiagoTimestamp(targetYear, targetMonth, targetDay, targetHour, targetMinute, targetSecond = 0) {
			// Crear una fecha aproximada (interpretada en la zona horaria local del navegador)
			let date = new Date(targetYear, targetMonth - 1, targetDay, targetHour, targetMinute, targetSecond);
			
			// Ajustar iterativamente hasta que la fecha en Santiago coincida con la objetivo
			for (let i = 0; i < 5; i++) {
				const formatter = new Intl.DateTimeFormat("en-US", {
					timeZone: "America/Santiago",
					year: "numeric",
					month: "2-digit",
					day: "2-digit",
					hour: "2-digit",
					minute: "2-digit",
					second: "2-digit",
					hour12: false
				});
				const parts = formatter.formatToParts(date);
				const santiagoYear = parseInt(parts.find(p => p.type === "year").value);
				const santiagoMonth = parseInt(parts.find(p => p.type === "month").value);
				const santiagoDay = parseInt(parts.find(p => p.type === "day").value);
				const santiagoHour = parseInt(parts.find(p => p.type === "hour").value);
				const santiagoMinute = parseInt(parts.find(p => p.type === "minute").value);
				
				// Si coincide exactamente, retornar
				if (santiagoYear === targetYear && santiagoMonth === targetMonth && 
				    santiagoDay === targetDay && santiagoHour === targetHour && 
				    santiagoMinute === targetMinute) {
					return date;
				}
				
				// Calcular la diferencia en milisegundos
				const targetDate = new Date(targetYear, targetMonth - 1, targetDay, targetHour, targetMinute, targetSecond);
				const santiagoDate = new Date(santiagoYear, santiagoMonth - 1, santiagoDay, santiagoHour, santiagoMinute, 0);
				const diff = targetDate.getTime() - santiagoDate.getTime();
				
				// Ajustar la fecha
				date = new Date(date.getTime() + diff);
			}
			
			return date;
		}

		// Función para obtener el timestamp de la fecha/hora actual en Santiago
		getSantiagoNowTimestamp() {
			const now = new Date();
			// Obtener los componentes de fecha/hora en Santiago
			const formatter = new Intl.DateTimeFormat("en-US", {
				timeZone: "America/Santiago",
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
				hour12: false
			});
			const parts = formatter.formatToParts(now);
			const year = parseInt(parts.find(p => p.type === "year").value);
			const month = parseInt(parts.find(p => p.type === "month").value);
			const day = parseInt(parts.find(p => p.type === "day").value);
			const hour = parseInt(parts.find(p => p.type === "hour").value);
			const minute = parseInt(parts.find(p => p.type === "minute").value);
			const second = parseInt(parts.find(p => p.type === "second").value);
			
			return this.getSantiagoTimestamp(year, month, day, hour, minute, second);
		}

		// Función para parsear la fecha en formato "YYYY-MM-DD HH:MM" o "YYYY-MM-DD"
		parseCountdownDate(dateString) {
			if (!dateString) return null;
			
			// Separar fecha y hora
			const parts = dateString.trim().split(' ');
			const datePart = parts[0]; // "YYYY-MM-DD"
			const timePart = parts[1] || "23:59"; // "HH:MM" o por defecto 23:59
			
			// Parsear fecha
			const [year, month, day] = datePart.split("-").map(Number);
			// Parsear hora
			const [hour, minute] = timePart.split(":").map(Number);
			
			return { year, month, day, hour, minute };
		}

		onInit() {
			this.completedCountdown = this.getAttribute("data-completed");
			this.countdown = this.querySelector(".countdown__main");
			this.countdownHeading = this.querySelector(".countdown__end-info");
			this.daysEl = this.querySelector(".countdown_block_days");
			this.hoursEl = this.querySelector(".countdown_block_hours");
			this.minutesEl = this.querySelector(".countdown_block_minutes");
			this.secondsEl = this.querySelector(".countdown_block_seconds");
			this.section = this.closest(".countdown-section");
			// ----------------------------------------------------------------
			// Si no hay fecha configurada, no hacer nada
			if (!this.countdownDateTo) {
				return;
			}
			
			// Parsear la fecha de fin
			const dateTo = this.parseCountdownDate(this.countdownDateTo);
			if (!dateTo) {
				return;
			}
			
			// Obtener fecha actual en Santiago, Chile
			const nowSantiago = this.getSantiagoNowTimestamp();
			// Crear fecha objetivo (fecha de fin) en Santiago, Chile
			const countdownDateSantiago = this.getSantiagoTimestamp(
				dateTo.year, 
				dateTo.month, 
				dateTo.day, 
				dateTo.hour, 
				dateTo.minute, 
				0
			);
			// Calcular la diferencia en milisegundos
			const distance = countdownDateSantiago.getTime() - nowSantiago.getTime();
			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			);
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);
			// ----------------------------------------------------------------
			if (distance < 0 && this.completedCountdown === "hide_section") {
				clearInterval(this.interval);
				this.countdown.style.display = "none";
				if (this.section) {
					this.section.style.display = "none";
				}
			} else if (distance < 0 && this.completedCountdown === "show_text") {
				this.countdown.style.display = "none";
				this.countdownHeading.style.display = "flex";
			} else {
				if (String(days).length === 1) this.daysEl.textContent = "0" + days;
				else this.daysEl.textContent = days;

				if (String(hours).length === 1) this.hoursEl.textContent = "0" + hours;
				else this.hoursEl.textContent = hours;

				if (String(minutes).length === 1)
					this.minutesEl.textContent = "0" + minutes;
				else this.minutesEl.textContent = minutes;

				if (String(seconds).length === 1)
					this.secondsEl.textContent = "0" + seconds;
				else this.secondsEl.textContent = seconds;
			}
		}

		setInterval() {
			clearInterval(this.interval);
			this.interval = setInterval(
				this.onInit.bind(this),
				1000
			);
		}
	}

	customElements.define("countdown-timer", Countdown);
}
